import { useProgress } from 'hooks/useProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import * as Layout from 'views/layouts/NewLayout'

const Iframe = styled.iframe`
  height: 100vh;
  border: 0px;
`

export const ReportPage: FC<{ reportData: { url: string; params?: Record<string, string> } }> = ({ reportData }) => {
  const [, sign] = useProgress(() =>
    apiClient.post(endpoints.signReport(), { reportUrl: reportData.url, ...reportData.params }),
  )
  const [signedReportUrl, setSignedReportUrl] = useState<string | undefined>()
  useEffect(() => {
    sign().then((response) => {
      setSignedReportUrl(response)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportData.url])
  return (
    <APageWrapper page="reports" place="reports">
      <Layout.WrapperContent>
        {signedReportUrl && <Iframe title={'report'} src={signedReportUrl} width="100%" />}
      </Layout.WrapperContent>
    </APageWrapper>
  )
}
